import { createStore, combineReducers } from "redux";
import navigation from "./reducer/Navigation";

export default createStore(
  combineReducers({
    navigation
  })
);
